import React, { Component } from 'react';

export default class InputFloating extends Component {
	constructor(props) {
		super(props);
		this.state = {
			focused: false
		}
	}

	componentDidMount = () => {
		if (this.props.type === 'date') {
			this.refs.d.children[1].setAttribute("class", "fl-lbl-up lll");
		}

		if (this.props.value) {
			this.refs.d.children[1].setAttribute("class", "fl-lbl-up lll");
		}
	}

	focused = (e) => {
		this.refs.d.children[1].setAttribute("class", "fl-lbl-up entered lll");
		this.refs.d.children[0].setAttribute("class", "in-mob-box entered-box");
		if (this.props.onFocus) {
			this.props.onFocus(e);
		}
		this.setState({ focused: true })
	}

	clicked = (e) => {
		this.refs.d.children[0].focus(e);
		this.focused();
	}



	blured = (e) => {
		if (!e.target.value && this.props.type !== 'date') {
			this.refs.d.children[1].setAttribute("class", "fl-lbl lll");
		} else {
			this.refs.d.children[1].setAttribute("class", "fl-lbl-up lll");
		}
		this.refs.d.children[0].setAttribute("class", "in-mob-box");
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
		this.setState({ focused: false })
	}

	onClick = (e) => {
		if (this.props.onClick) {
			this.props.onClick(e);
		}
	}

	onChange = (e) => {
		if (this.props.onChange) {
			this.props.onChange(e);
		}
	}

	onKeyUp = (e) => {
		if (this.props.onKeyUp) {
			this.props.onKeyUp(e);
		}
	}

	render() {
		const { type, value, label, name, id, disabled } = this.props;
		return (
			<div className={disabled ? 'disabledInput': null}>
				<div style={{ position: 'relative' }} ref="d">
					<input type={type} className="in-mob-box" id={id} name={name} onFocus={this.focused} onBlur={this.blured} onClick={this.onClick} onChange={this.onChange} onKeyUp={this.onKeyUp} value={value} disabled={disabled} />
					<label className="fl-lbl lll" onClick={this.clicked}>{label}</label>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/commons/InputFloating.js